var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5607 1.58453C12.2143 0.939693 11.6657 0.446239 11.0113 0.191148C10.3569 -0.0637161 9.63935 -0.0637161 8.98502 0.191148C8.33064 0.446251 7.78199 0.939693 7.43563 1.58453L0.442562 14.6427C-0.151224 15.7505 -0.147262 17.1118 0.453025 18.2159C1.05312 19.3198 2.15866 19.9995 3.35494 20H16.6419C17.8388 20.0007 18.9452 19.3215 19.5462 18.2173C20.1472 17.1132 20.1515 15.7512 19.5575 14.6427L12.5607 1.58453ZM16.6416 17.9996H3.35469C2.82653 18.0001 2.33826 17.7006 2.07275 17.2134C1.80748 16.7265 1.8053 16.1254 2.06709 15.6361L9.06071 2.57793C9.1867 2.3412 9.38746 2.15982 9.62699 2.0661C9.86676 1.97238 10.1296 1.97238 10.3694 2.0661C10.609 2.15981 10.8097 2.3412 10.9357 2.57793L17.9293 15.6361C18.1911 16.1253 18.1889 16.7264 17.9237 17.2134C17.6582 17.7006 17.1699 18.0001 16.6417 17.9996H16.6416Z",
    fill: "#FF6868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96552 6.42856H11.0345V11.4286H8.96552V6.42856Z",
    fill: "#FF6868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0345 14.6427C11.0345 15.2347 10.5712 15.7143 10 15.7143C9.42875 15.7143 8.96552 15.2347 8.96552 14.6427C8.96552 14.051 9.42875 13.5714 10 13.5714C10.5712 13.5714 11.0345 14.051 11.0345 14.6427Z",
    fill: "#FF6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.110257f62f44e4df800d9a93715a2638.svg";
export { ForwardRef as ReactComponent };